// types
import { Tag } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Alert, Chip, Box, Grid } from '@mui/material';

// props
export interface TagsProps {
	tags: Tag[];
}

export const Tags = ({ tags = [] }: TagsProps) => {
	console.log('Tags', tags);

	// hooks
	const { t } = useTranslation();

	const renderContent = () => {
		if (tags.length) {
			return (
				<Grid container spacing={2}>
					{tags.map((tag) => {
						return (
							<Grid item key={tag.name}>
								<Chip label={tag.name} variant="outlined" />
							</Grid>
						);
					})}
				</Grid>
			);
		}

		return (
			<Alert severity="info" sx={{ borderRadius: 0 }}>
				{t('alert.tagsNotFound')}
			</Alert>
		);
	};

	return (
		<Box
			sx={(theme) => {
				return {
					padding: tags.length ? theme.spacing(2) : 0,
				};
			}}>
			{renderContent()}
		</Box>
	);
};
